import React from 'react';
import { createPortal } from 'react-dom';
import '../../styles/profileSheet.css';

/**
 * Animated bottom/center form sheet (matches UserProfileView Edit Guardian pattern).
 */
const ProfileFormSheet = ({
  open,
  onClose,
  title,
  titleId,
  subtext,
  children,
  footer,
  dismissOnOverlay = false,
  closeDisabled = false,
  panelClassName = '',
  overlayClassName = ''
}) => {
  if (!open) return null;

  const overlayClasses = ['profile-sheet-overlay', 'profile-sheet-overlay--raised', overlayClassName]
    .filter(Boolean)
    .join(' ');
  const panelClasses = ['profile-sheet-panel', 'profile-sheet-panel--form', panelClassName]
    .filter(Boolean)
    .join(' ');

  return createPortal(
    <div
      className={overlayClasses}
      role="presentation"
      onClick={dismissOnOverlay && !closeDisabled ? onClose : undefined}
    >
      <div
        className={panelClasses}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="profile-sheet-header">
          <div className="profile-sheet-header-main">
            <h2 id={titleId} className="profile-sheet-title">
              {title}
            </h2>
            {subtext ? <p className="profile-sheet-subtext">{subtext}</p> : null}
          </div>
          <button
            type="button"
            className="profile-sheet-close"
            onClick={onClose}
            disabled={closeDisabled}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="profile-sheet-form-body">{children}</div>
        {footer ? <div className="profile-sheet-actions">{footer}</div> : null}
      </div>
    </div>,
    document.body
  );
};

export default ProfileFormSheet;
